export default __webpack_public_path__ + "e523caae0c3052e04efc59bde500293b.png";